import { getEntityRef } from "@client/content/lib/helper";
import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import Form, { type FormProps } from "@client/controls/Form/component";
import { type EntityRef } from "@client/types";
import React from "react";

export type Props = EntityRef & FormProps;

export default React.forwardRef(({ id, source, ...props }: Props, ref: React.RefObject<any>) => (
  <FormStyleProvider {...getEntityRef({ id, source })}>
    <Form ref={ref} {...props} />
  </FormStyleProvider>
));
